import * as React from 'react';
import {translate} from 'react-i18next';
import {connect} from 'react-redux';
import {compose, Dispatch} from 'redux';
import {Table} from 'semantic-ui-react';
import AdminViewActions from '../../../redux/actions/AdminViewActions';
import SelectField from '../../../components/SelectField';
import {ITranslatedComponent} from '../../../redux/reducers/generalReducer';
import {CategoryTextSortDto, ModelyearDto, ResourceListOfModelyearDto} from '../../../services/Client';
import {DragDropContext, Draggable, DraggableProvided, DraggableStateSnapshot, Droppable, DroppableProvided, DroppableStateSnapshot, DropResult} from 'react-beautiful-dnd';
import {CategorySortTableRow} from './CategorySortTableRow';
import {CategorySortTableHeader} from './CategorySortTableHeader';
import {CategorySortButtonHeader} from './CategorySortButtonHeader';
import HATEOASClient from '../../../services/HATEOASClient';
import {selectClient, selectModelyearCategories, selectModelyears} from '../../../redux/selectors';
import {IReduxState} from '../../../redux/IReduxState';

interface IMapDispatchToProps {
    getModelyearCategories: (modelyear: ModelyearDto) => void;
    unloadModelyearCategories: () => void;
    moveCategory: (dto: CategoryTextSortDto[], toPosition: number, modelyear: ModelyearDto) => void;
}

interface IMapStateToProps {
    modelYears?: ResourceListOfModelyearDto;
    modelYearCategories: CategoryTextSortDto[];
    client: HATEOASClient;
}

interface IOwnProps {

}

interface ICategorySortProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent {

}

interface ICategorySortState {
    editMode: boolean;
    selectedModelyear?: ModelyearDto;
    groupedModelYearCategories: Map<number, CategoryTextSortDto[]>;
}

class CategorySort extends React.Component<ICategorySortProps, ICategorySortState> {

    constructor(props: ICategorySortProps) {
        super(props);

        this.state = {
            editMode: false,
            selectedModelyear: undefined,
            groupedModelYearCategories: new Map()
        };
    }

    componentWillUnmount() {
        this.props.unloadModelyearCategories();
    }

    componentDidUpdate(prevProps: ICategorySortProps, prevState: ICategorySortState) {
        if (this.state.selectedModelyear && prevState.selectedModelyear !== this.state.selectedModelyear) {
            this.props.getModelyearCategories(this.state.selectedModelyear);
        }

        if (this.props.modelYearCategories && prevProps.modelYearCategories !== this.props.modelYearCategories) {
            let map = new Map();
            this.props.modelYearCategories.forEach(value => {
                if (!map[value.proMTSequence]) {
                    map[value.proMTSequence] = [];
                }
                map[value.proMTSequence].push(value);
            });

            this.setState({groupedModelYearCategories: map});
        }
    }

    onDragEnd = (result: DropResult) => {
        // if not dropped outside the list and position different than initial
        if (result.destination && result.destination.index !== result.source.index) {

            let movedCategoryDto: CategoryTextSortDto[] = new Array();
            this.state.groupedModelYearCategories[result.source.index].map(
                (val: CategoryTextSortDto) => movedCategoryDto.push(val)
            );

            const targetIndex = this.state.groupedModelYearCategories[result.destination.index][0].proMTSequence;

            if (movedCategoryDto[0].proMTSequence && targetIndex && this.state.selectedModelyear) {
                this.props.moveCategory(movedCategoryDto, targetIndex, this.state.selectedModelyear);
            }
        }
    }

    renderTableRow = () => {
        const editMode = this.state.editMode;
        let index: number = 0;
        const groupedModelYearCategories = this.state.groupedModelYearCategories;

        return Object.keys(groupedModelYearCategories).map(value => groupedModelYearCategories[value]).map((dto: CategoryTextSortDto[]) => {
            index++;
            const thisIndex = index;

            return (
                <Draggable
                    key={dto[0].proMTSequence}
                    draggableId={dto[0].proMTSequence.toString()}
                    index={thisIndex}
                    isDragDisabled={!editMode}
                >
                    {(provided2: DraggableProvided, snapshot2: DraggableStateSnapshot) =>
                        <>
                            <CategorySortTableRow
                                provided={provided2}
                                snapshot={snapshot2}
                                row={dto}
                                index={thisIndex}
                            />
                        </>

                    }
                </Draggable>
            );
        });
    }

    render() {
        const {t, modelYearCategories, getModelyearCategories, client, modelYears} = this.props;
        const {selectedModelyear, editMode} = this.state;

        return (
            <>
                <CategorySortButtonHeader
                    disabled={selectedModelyear === undefined}
                    editMode={editMode}
                    canEdit={selectedModelyear !== undefined && modelYearCategories.length > 0 &&
                        modelYearCategories.every(val => client.PATCH_moveCategory(val).canExecute())}
                    onEditClick={() => this.setState({editMode: !editMode})}
                    onReload={() => selectedModelyear && getModelyearCategories(selectedModelyear)}
                    t={t}
                />

                <div className={"margin-top--10px margin-bottom--10px"}>
                    <SelectField
                        placeholder={t("CATEGORY_SORT:SELECT_MODELYEAR")}
                        searchable={true}
                        clearable={false}
                        dataSource={modelYears && modelYears.elements ? modelYears.elements : []}
                        valueComparator={(actual: ModelyearDto, expected: ModelyearDto) => actual.objectId === expected.objectId}
                        value={selectedModelyear}
                        rendererKey={(modelyear: ModelyearDto) => modelyear.mj4 + '(' + modelyear.mj1 + ')'}
                        onChange={(selectedValue: ModelyearDto) =>
                            this.setState({selectedModelyear: selectedValue})}
                    />
                </div>

                <div style={{overflowY: "auto", paddingBottom: 20}}>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId={"droppable"}>
                            {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
                                <table
                                    className={"ui celled center aligned table"}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    <CategorySortTableHeader t={t} />

                                    <Table.Body>
                                        {modelYearCategories.length > 0
                                            ? this.renderTableRow()
                                            :
                                            <Table.Row>
                                                <Table.Cell colSpan={'5'} style={{fontWeight: 700, fontSize: 30, color: '#d3d3d3'}}>
                                                    {t("GLOBAL:NO_DATA")}
                                                </Table.Cell>
                                            </Table.Row>
                                        }
                                        {provided.placeholder}
                                    </Table.Body>
                                </table>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    modelYears: selectModelyears(state),
    modelYearCategories: selectModelyearCategories(state),
    client: selectClient(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: ICategorySortProps): IMapDispatchToProps => ({
    getModelyearCategories: (modelyear: ModelyearDto) => dispatch(AdminViewActions.GetModelyearCategories(ownProps.t, modelyear)),
    unloadModelyearCategories: () => dispatch(AdminViewActions.UnloadModelyearCategories()),
    moveCategory: (dto: CategoryTextSortDto[], toPosition: number, modelyear: ModelyearDto) =>
        dispatch(AdminViewActions.UpdateCategoryPosition(ownProps.t, dto, toPosition, modelyear))
});

export default compose<React.ComponentType<IOwnProps>>(
    translate("CATEGORY_SORT"),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(CategorySort);



// WEBPACK FOOTER //
// ./src/views/AdminView/CategorySortTab/CategorySort.tsx